import React from 'react';
import { ProductIcon, SellOutIcon, StarIcon } from '@assets/icons';
import { LeftArrowIcon, InformationIcon } from '@assets/icons/index';
import { Box, Flex, Skeleton, Text } from '@chakra-ui/react';
import SearchBar from '@components/searchBar';
import TableAddItem from '@components/TableAddItem';
import { useNavigate, useParams } from 'react-router-dom';
import { tableList as tableListSKU } from '@pages/ConsumerPromotion/components/Detail/EditSku/table/const';
import { useFilters } from '@pages/ConsumerPromotion/hooks/state/useFilters';
import { debounce } from 'lodash';
import { useGetCustomerDetail } from '@pages/ConsumerPromotion/hooks/query/useGetCustomerList';
import BoxContainer from './BoxContainer';
import StatCard from './StatCard';
import { ConditionalComponent } from '@components/functionComponent';
import SkeletonComponent from '@components/skeleton';
import { formatCurrency } from '@helpers/utils';

const tableList = [
    ...tableListSKU,
    {
        title: <Text fontWeight={700}>Sellout</Text>,
        value: 'sellout',
        width: 152,
        component: ({ value }) => value,
    },
];

export default function DetailCustomer() {
    const navigate = useNavigate();
    const filters = useFilters();
    const { customerId } = useParams();

    const params = {
        search: filters.search,
        page: filters.page,
        limit: filters.limit,
    };

    const { data, isLoading } = useGetCustomerDetail(customerId, params);

    const handleSearchTable = debounce((e) => {
        const search = e.target.value.toLowerCase();
        filters.set({ search, page: 1 });
    }, 500);

    return (
        <Box>
            <BoxContainer>
                <Flex justifyContent="space-between">
                    <Box alignSelf="start" mt="4px" onClick={() => navigate(-1)} cursor="pointer">
                        <LeftArrowIcon />
                    </Box>
                    <Box flex={1} ml="12px">
                        <ConditionalComponent
                            statement={!isLoading}
                            fallback={<SkeletonComponent height={'30px'} width={'50%'} />}
                        >
                            <Text fontWeight={700} fontSize={'sm'}>
                                {data?.data?.customer_name}
                            </Text>
                        </ConditionalComponent>
                        <Flex gap="8px">
                            <InformationIcon />
                            <Text>Tidak ada pembaruan terbaru untuk saat ini.</Text>
                        </Flex>
                    </Box>
                </Flex>
            </BoxContainer>

            <BoxContainer mt="24px">
                <Flex gap="24px">
                    <StatCard
                        icon={<SellOutIcon />}
                        label="Total Sellout"
                        value={formatCurrency(data?.data?.total_sellout)}
                    />

                    <StatCard
                        icon={<ProductIcon />}
                        label="Total SKU"
                        value={Number(data?.data?.total_sku || 0).toLocaleString('id-ID')}
                    />
                    <StatCard
                        icon={<StarIcon />}
                        label="Total Brand"
                        value={Number(data?.data?.total_brand || 0).toLocaleString('id-ID')}
                    />
                </Flex>
            </BoxContainer>

            <BoxContainer mt="24px">
                <Text fontSize={'sm'} fontWeight={700} mb="24px">
                    Daftar SKU
                </Text>

                <SearchBar placeholder="Cari nama atau ID produk" mb="24px" onChange={handleSearchTable} />

                <TableAddItem
                    tableList={tableList}
                    data={data?.data?.page_data}
                    totalData={data?.data?.total}
                    isLoading={isLoading}
                    isAddItem={false}
                    groupBy={(item) => (item?.is_basepack ? 'BASEPACK' : 'PRODUK SATUAN')}
                    limit={filters.limit}
                    page={filters.page}
                    pageCount={filters.total_page}
                    onPageChange={({ selected }) => filters.set({ page: selected + 1 })}
                    onChangeLimit={(e) => filters.set({ page: 1, limit: e.target.value })}
                />
            </BoxContainer>
        </Box>
    );
}
